import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import { injectStore } from "../services/api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

injectStore(store);